import React, { useMemo } from "react";
import { getModelScreenerNumericCellValue } from "@pages/managed-accounts/model-screener/utils";
import { SHTypography } from "@components/design-systems";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";

export const MSTableCurrencyCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    const value = useMemo(() => {
      return getModelScreenerNumericCellValue({
        cellValue: cellData.value,
        prefix: "$",
      });
    }, [cellData]);

    return (
      <SHTypography variant={"body2"} fontSize={13} lineHeight={1.2}>
        {value}
      </SHTypography>
    );
  },
);
